/* Copyright (c) 2018-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { BridgeCommands } from 'bridge-commands/bridge.commands';
import { LoggingService } from '../logging/logging.service';
import { BridgeMockService } from './bridge.mocks.service';
import { BridgeService } from './bridge.service';

@Injectable()
export class YggdrasilService extends BridgeService {
    constructor(
        loggingService: LoggingService,
        private ngZone: NgZone,
        bridgeMocks?: BridgeMockService
    ) {
        super(loggingService.getLogger('crimson/yggdrasil'), bridgeMocks);
    }

    executeCommandInternal<ParamType extends object, ResponseType>(
        command: BridgeCommands.Command<ParamType, ResponseType>,
        params: ParamType
    ): Observable<ResponseType> {
        // TODO : implement yggdrasil bridge
        return new Observable(observer => {
            observer.next(null);
            observer.complete();
        });
    }
}
